import Skeleton from '@mui/material/Skeleton';

import { SkillMosaicWrapper } from './components/SkillMosaicWrapper';

import type { FunctionComponent } from 'react';

export const SkillMosaicSkeleton: FunctionComponent = () => {
    return (
        <SkillMosaicWrapper>
            <Skeleton animation="wave" height="100%" variant="rounded" />
        </SkillMosaicWrapper>
    );
};
